export const API_URL =
  process.env.REACT_APP_HOST === "localhost"
    ? "http://localhost:8000"
    : "https://api.originalmarinesoutlet.com";
export const API_URL_IMAGE_ITEM = API_URL + "/images/products/";
export const API_URL_IMAGE_RESIZED = API_URL + "/api/products/images/edited/";
